import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupSlideTheme from '@swup/slide-theme';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';



UIkit.use(Icons);

const swup = new Swup({
    containers: ['#swup', '.site-header .uk-navbar-nav > li'],
    linkSelector:
        'a[href^="' +
        window.location.origin +
        '"]:not([data-no-swup]),' +
        'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.rex-minibar-close):not(.rex-minibar-opener),' +
        'a[href^="#"]:not([data-no-swup]):not([target="_blank"])',
    animateHistoryBrowsing: true,
    plugins: [
        new SwupScrollPlugin({
            animateScroll: false
        }),
        new SwupSlideTheme({
            reversed: true
        }),
        new SwupPreloadPlugin(),
        new SwupHeadPlugin(),
        new SwupScriptsPlugin({
            head: true,
            body: true
        }),
        new SwupA11yPlugin({
            announcementTemplate: "Navigiert zu: {title}",
            urlTemplate: "Neue Seite unter {url}"
        })
    ]
});

window.addEventListener('load', init);
swup.on('pageView', init);
swup.on('animationOutStart', hideOffcanvas)
swup.on('samePage', hideOffcanvas);

function init() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        });
    }



}

function hideOffcanvas() {
    UIkit.offcanvas('.mobile-navigation').hide();
}



function initializeMap() {
    let sites = document.querySelectorAll('.sites .wrapper');
    let mapBg = document.querySelector('.bg-map');

    sites.forEach(function (element) {
        let infobox = element.querySelector('.sites-infobox');
        let marker = element.querySelector('.sites-dot');

        marker.addEventListener('click', function () {
            // Close all other infoboxes
            sites.forEach(function (otherElement) {
                if (otherElement !== element) {
                    let otherInfobox = otherElement.querySelector('.sites-infobox');
                    otherInfobox.classList.remove('sites-infobox-show');
                }
            });
            // Toggle the infobox for the clicked element
            infobox.classList.toggle('sites-infobox-show');
        });
    });

    if (mapBg) {
        mapBg.addEventListener('click', function (event) {
            // Close all infoboxes when clicking elsewhere on the map-bg
            if (!event.target.closest('.wrapper')) {
                sites.forEach(function (element) {
                    let infobox = element.querySelector('.sites-infobox');
                    infobox.classList.remove('sites-infobox-show');
                });
            }
        });
    }
}
initializeMap();
document.addEventListener('swup:contentReplaced', initializeMap);

window.addEventListener('load', function () {

    // Reduce height of navbar when scrolling down
    /*
        window.addEventListener('scroll', function() {
            let header = document.querySelector('.site-header');
            let topbar = document.querySelector('.site-topbar-navbar');
            let logo = document.querySelector('.uk-logo');

            if (window.scrollY >= 150) {
                header.classList.add('header-scroll');
                topbar.classList.add('topbar-scroll');
                logo.classList.add('logo-scroll');
            } else {
                if(header.classList.contains('header-scroll')){
                    header.classList.remove('header-scroll');
                }
                if(topbar.classList.contains('topbar-scroll')){
                    topbar.classList.remove('topbar-scroll');
                }
                if(logo.classList.contains('logo-scroll')){
                    logo.classList.remove('logo-scroll');
                }
            }
        });

    */

    // Function to debounce scroll events
    function debounce(func, delay) {
        let timeoutId;
        return function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(func, delay);
        };
    }

// Your scroll event listener function
    function handleScroll() {
        let header = document.querySelector('.site-header:not(.portal)');
        if (header) {
            let topbar = document.querySelector('.site-topbar-navbar');
            let logo = document.querySelector('.uk-logo');

            if (window.scrollY >= 100) {
                header.classList.add('header-scroll');
                topbar.classList.add('topbar-scroll');
                logo.classList.add('logo-scroll');
            } else {
                header.classList.remove('header-scroll');
                topbar.classList.remove('topbar-scroll');
                logo.classList.remove('logo-scroll');
            }
        }
    }

// Debounce the scroll event listener
    const debouncedScroll = debounce(handleScroll, 150); // Adjust the delay as needed

// Add the debounced event listener
    window.addEventListener('scroll', debouncedScroll);


    const header = document.querySelector('.site-header');
    const headerHeight = header.offsetHeight;
    //console.log(headerHeight);
    setTimeout(function () {
        let url = window.location.href;
        if (url.includes('-st_hedwig')) {

            const startMarker = "#";
            const endMarker = "-st_hedwig";

            const startIndex = url.indexOf(startMarker);
            const endIndex = url.indexOf(endMarker);

            if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
                const scrollto = url.slice(startIndex + 1, endIndex);
                let sectionElem = document.getElementById(scrollto);
                let scrollpos = sectionElem.getBoundingClientRect();
                let scrollposTop = scrollpos.top - headerHeight;

                // Scroll to position of Element
                window.scrollTo(0, scrollposTop);

            }
        }
    }, 150);


    let teaserLarge = document.querySelectorAll('.cardTeaserLarge');
    teaserLarge.forEach(function (item) {
        item.addEventListener('click', (event) => {
            let link = event.target.querySelector('.card-header a');
            link.classList.add('pointer-auto');
        });
    });


    const urlParams = new URLSearchParams(window.location.search);
    const additionalInfo = urlParams.get('info');
    const getTitle = document.querySelector('.gettitle');
    if (additionalInfo !== null) {
        if (getTitle) {
            getTitle.value = additionalInfo;
        }
    }


    let experienceArray = Array.from(document.querySelectorAll('.experience'));
    let traineeName = experienceArray[0];
    //let traineeName = document.getElementById('yform-formular-field-4-ja');
    let traineeNameNo = experienceArray[1];
    //let traineeNameNo = document.getElementById('yform-formular-field-4-nein');

    let hiddenTrainee = document.getElementById('bewform-hidden');




    if (experienceArray.length > 0){
        let hiddenTraineeInput = hiddenTrainee.querySelector('input');

        traineeName.addEventListener("change", function () {
            hiddenTrainee.classList.remove('uk-hidden');
            hiddenTraineeInput.value = '';
        })
        traineeNameNo.addEventListener("change", function () {
            hiddenTrainee.classList.add('uk-hidden');
            hiddenTraineeInput.value = 'Bitte eingeben';
        })
    };

    let jobExpArray = Array.from(document.querySelectorAll('.jobexp'));

    let experienceName = jobExpArray[0];
    //let experienceName = document.getElementById('yform-formular-field-10-ja');
    let experienceNameNo = jobExpArray[1];
    //let experienceNameNo = document.getElementById('yform-formular-field-10-nein');

    let hiddenExperience = document.getElementById('bewform-erfahrung');
    if(hiddenExperience) {
        let hiddenExperienceInput = hiddenExperience.querySelector('input');
    }

    experienceName.addEventListener("change", function(){
        hiddenExperience.classList.remove('uk-hidden');
        hiddenExperienceInput.value = '';
    })
    experienceNameNo.addEventListener("change", function(){
        hiddenExperience.classList.add('uk-hidden');
        hiddenExperienceInput.value = 'Bitte eingeben';
    })

    let contactArray = Array.from(document.querySelectorAll('.contactchoice'));
    let contactTel = contactArray[0];
    //let contactTel = document.getElementById('yform-formular-field-26-telefon');
    let hiddenTel = document.getElementById('contact-telefon');
    let hiddenTelInput = hiddenTel.querySelector('input');

    let contactMail = contactArray[1];
    //let contactMail = document.getElementById('yform-formular-field-26-e-mail');
    let hiddenMail = document.getElementById('contact-mail');
    let hiddenMailInput = hiddenMail.querySelector('input');


    contactTel.addEventListener("change", function(){
        hiddenTel.classList.remove('uk-hidden');
        hiddenTelInput.value = '';
        if(! hiddenMail.classList.contains('uk-hidden')){
            hiddenMail.classList.add('uk-hidden');
            hiddenMailInput.value = 'muster@mail.de'
        }
    })
    contactMail.addEventListener("change", function(){
        hiddenMail.classList.remove('uk-hidden');
        hiddenMailInput.value = '';
        if(! hiddenTel.classList.contains('uk-hidden')){
            hiddenTel.classList.add('uk-hidden');
            hiddenTelInput.value = '0000';
        }
    })




});


